import * as React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Auth from "./Auth";

export const Router: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/*" element={<Auth />}></Route>
    </Routes>
  </BrowserRouter>
);
